import { ModelForm } from '@/components/view/super/model-dialog/all.type';
import index from './index.vue';

export default index;
export {
    ModelForm
};